import React from "react";
import { Trans, useTranslation } from "react-i18next";
interface Props {
  children?: JSX.Element;
}

const FormBorder: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className="relative z-0 border border-gray-500 lg:mx-5">
      <div className="absolute -top-3 left-[10px] lg:left-14 bg-[#E5E5E5] px-[10px] lg:px-5">
        <h1 className="lg:text-3xl font-bold text-[#1E408E]">
          <Trans t={t}>Event Details</Trans>
        </h1>
      </div>
      <div className="md:p-16 sm:p-8 p-4 pt-8 lg:pt-16">{children}</div>
    </div>
  );
};

export default FormBorder;
